// department.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useDepartmentStore = defineStore('department', {
    state: () => ({
        allDepartment: [],
        departmentList: [],
    }),
    actions: {
        async getAllDepartment(filter) {
            try {
                const response = await axios.get('/departments', { params: filter })
                if (response.status === 200) {
                    this.allDepartment = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getDepartment(filter) {
            try {
                const response = await axios.get('/departments', { params: filter })
                if (response.status === 200) {
                    this.departmentList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getDepartmentById(id) {
            try {
                const response = await axios.get(`/department/${id}`)
                if (response.status === 200) {
                    console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createDepartment(body) {
            try {
                const response = await axios.post('/department', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateDepartment(body) {
            try {
                const response = await axios.post(`/department/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async departmentDeleteCheck(id, filter) {
            try {
                const response = await axios.get(`/department/${id}/deletion-check`, { params: filter, noLoader: true })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteDepartment(id) {
            try {
                const response = await axios.delete(`/department/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})